import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-coordonnees-bancaires',
  templateUrl: './coordonnees-bancaires.component.html',
  styleUrls: ['./coordonnees-bancaires.component.scss']
})
export class CoordonneesBancairesComponent implements OnInit {

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private readonly configurationService: ConfigurationService) { }
  public fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);
  ngOnInit(): void {
  }
  configuration = this.configurationService.get();

}
